/* @flow */

import _scheduler from './scheduler';
import { isFunction } from './coreutils';

/**
 * Scheduler using setImmediate
 *
 * @class _immediateScheduler
 * @augments _scheduler
 */
export default class _immediateScheduler extends _scheduler<?TimeoutID> {
  static isSupported(): boolean {
    return isFunction(window.setImmediate) && isFunction(window.clearImmediate);
  }

  constructor(n: string) {
    super(n);
    this._tid = null;
  }

  _clear() {
    if (this._tid) {
      clearImmediate(this._tid);
      this._tid = null;
    }
  }

  _schedule() {
    this._tid = setImmediate(() => this._processEntry(), this.delay);
  }
}
